/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Bank: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <circle cx='16' cy='16' r='16' fill='#959595' />
    <path
      d='M15.7 9.31c.22-.1.48-.08.7.05l6.5 4a.75.75 0 0 1-.4 1.39h-.75v6h.83a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1 0-1.5h.75v-6H9.5a.75.75 0 0 1-.4-1.39l6.5-4 .1-.05Zm1.05 5.44v6h3.5v-6h-3.5Zm-5 6h3.5v-6h-3.5v6Zm.4-7.5h7.7L16 10.88l-3.85 2.37Z'
      fill='#fff'
    />
  </React.Fragment>
)
